var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 4.60002C7.913 4.60002 4.5999 7.91312 4.5999 12C4.5999 16.0869 7.913 19.4 11.9999 19.4C16.0868 19.4 19.3999 16.0869 19.3999 12C19.3999 7.91312 16.0868 4.60002 11.9999 4.60002ZM3.3999 12C3.3999 7.25038 7.25025 3.40002 11.9999 3.40002C16.7496 3.40002 20.5999 7.25038 20.5999 12C20.5999 16.7497 16.7495 20.6 11.9999 20.6C7.25025 20.6 3.3999 16.7497 3.3999 12ZM11.9999 7.96003C12.3313 7.96003 12.5999 8.22865 12.5999 8.56003V8.57145C12.5999 8.90282 12.3313 9.17145 11.9999 9.17145C11.6685 9.17145 11.3999 8.90282 11.3999 8.57145V8.56003C11.3999 8.22865 11.6685 7.96003 11.9999 7.96003ZM9.68562 11.4286C9.68562 11.0972 9.95425 10.8286 10.2856 10.8286H12.5999V14.8286H13.7142C14.0456 14.8286 14.3142 15.0972 14.3142 15.4286C14.3142 15.76 14.0456 16.0286 13.7142 16.0286H10.2856C9.95425 16.0286 9.68562 15.76 9.68562 15.4286C9.68562 15.0972 9.95425 14.8286 10.2856 14.8286H11.3999V12.0286H10.2856C9.95425 12.0286 9.68562 11.76 9.68562 11.4286Z",
    fill: "#667C99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d48c67fff2bea5fc90703e5093f67b2e.svg";
export { ForwardRef as ReactComponent };